import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RxFormGroup } from "@rxweb/reactive-form-validators";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class UsersService {
	baseUrl = `${environment.apis.base}/users`;
	socketBaseUrl = `${environment.apis.socketUrl}/users`

	constructor(private readonly http: HttpClient) {}

	datatable(page?: number, options?: any): Observable<any> {
		let httpParams = new HttpParams();

		if (typeof page === "number") {
			httpParams = httpParams.append("page", page);
		}

		if ("key" in options && options.key.trim() !== "") {
			httpParams = httpParams.append("search", options.key);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

	show(id: number): Promise<any> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	showUsersSocket(): Promise<any> {
		const url = `${this.socketBaseUrl}/socket/all`;

		return this.http.get<any>(url).toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			return this.http.put<any>(url, data.value);
		} else {
			return this.http.post<any>(url, data.value);
		}
	}

	update(data: any, id: number): Observable<Object> {
		let url = this.baseUrl;

		url += `/${id}`;
		return this.http.put<any>(url, data);
	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}
}
